import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const RequestWithdrawalPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">売上金の振込申請手順</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              売上金は、振込申請に基づき、指定された銀行口座へお振込いたします。<br/>
              ただし、売上金には振込申請の期限が設定されており、期限を過ぎた場合は自動的に失効となります。<br/>
              失効後の売上金は、いかなる理由であっても復元できません。
            </div>
            <div className="flex flex-col justify-start items-start">
              <div className="justify-center text-black text-base font-normal leading-7">詳しくは、以下のページをご確認ください。</div>
              <Link to={`/terms/sale_transfer${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">売上金・振込について</Link>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">対応手順（ウェブ版）</div>
            </div>
            <div className="justify-center text-black text-base font-normal leading-7">
              1. 「マイページ」をタップ<br/>
              2. 「メニュー」をタップ<br/>
              3. 「売上・振込申請管理」をタップ<br/>
              4. 「振込申請」をタップ<br/>
              5. 口座情報を記入・選択<br/>
              6. 「振込申請」をタップ
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">対応手順（アプリ版）</div>
            </div>
            <div className="justify-center text-black text-base font-normal leading-7">
              1. 「マイページ」をタップ<br/>
              2. 「売上・振込申請管理」をタップ<br/>
              3. 「振込申請」をタップ<br/>
              4. 口座情報を記入・選択<br/>
              5. 「振込申請」をタップ
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default RequestWithdrawalPage;